import React from 'react';
import { IconButton, Stack, Typography, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { useSelector } from 'react-redux';
import { RiCloseLine } from 'react-icons/ri';
import * as RentalViewSelectors from 'selectors/RentalViewSelectors';
import GeneralDetails from './GeneralDetails';
import ContactDetails from './ContactDetails';
import DeliveryDetails from './DeliveryDetails';
import ProductDetails from './ProductDetails';
import { useTranslation } from 'services/localization';

export interface Props {
	open: boolean;
	onClose: () => void;
}
const OrderSummaryDialog = (props: Props) => {
	const { open, onClose } = props;
	const { t } = useTranslation();
	const delivery = useSelector(RentalViewSelectors.orderDelivery);

	return (
		<Dialog fullScreen open={open} onClose={onClose}>
			<DialogTitle
				sx={{
					backgroundColor: (theme) => theme.palette.background.paper,
					borderBottom: (theme) => `1px solid ${theme.palette.border.paper}`,
				}}
			>
				<Stack direction="row" alignItems="center">
					<IconButton sx={{ minWidth: 0 }} onClick={onClose} aria-label="Close" size="large">
						<RiCloseLine size={24} />
					</IconButton>
					<Typography sx={{ fontWeight: 500, fontSize: '1.8rem' }}>
						{t('orderSummaryDialog.header', 'Order summary')}
					</Typography>
				</Stack>
			</DialogTitle>
			<DialogContent sx={{ backgroundColor: (theme) => theme.palette.background.default }}>
				<GeneralDetails />
				<ContactDetails />
				{!!delivery && <DeliveryDetails delivery={delivery} />}
				<ProductDetails />
			</DialogContent>
		</Dialog>
	);
};

export default OrderSummaryDialog;
